function Timer({ children, className, ...restProps }) {
  return (
    <span className={`timer ${className}`} {...restProps}>
      {children}
    </span>
  );
}

export default Timer;
